import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChange,
    SimpleChanges
} from '@angular/core';
import {FormGroup} from "@angular/forms";
import {CustomerAddress} from "@biletix/core/models/customer/customer-address.model";
import {MatDialog} from "@angular/material/dialog";
import {CustomerAccountService} from "@biletix/core/services/customer-account.service";
import {AbstractionComponent} from "@biletix/core/common/abstraction-component";
import {EditCustomerAddressData} from "@biletix/core/models/customer/edit-customer-address-data.model";
import {EditCustomerAddressComponent} from "@biletix/shared/components/customer/edit-customer-address/edit-customer-address.component";

@Component({
    selector: 'btx-address-item-detail',
    templateUrl: './address-item-detail.component.html',
    styleUrls: ['./address-item-detail.component.scss'],
  standalone: false
})
export class AddressItemDetailComponent extends AbstractionComponent implements OnInit, OnChanges, OnDestroy {

    @Input("group") group: FormGroup | any;
    @Input("value") value: number | any;


    @Input("selectionMode") selectionMode: boolean = false;
    @Input("address") address!: CustomerAddress;
    @Input("isDeliveryAddress") isDeliveryAddress: boolean = true;


    @Output("removed") removed = new EventEmitter<CustomerAddress>();
    @Output("edited") edited = new EventEmitter<CustomerAddress>();
    @Output("selectionChange") selectionChange = new EventEmitter<number | null>();

    selectedAddressId?: number;

    constructor(private dialog: MatDialog,
                private customerAccountService: CustomerAccountService) {
        super();
    }

    ngOnInit(): void {
        this.selectedAddressId = this.value;
    }

    addressItemClasses() {
        return {
            checked: this.isSelected()
        }
    }

    isSelected(): boolean {
        if (!this.selectionMode)
            return false;

        return this.selectedAddressId == this.address.id;
    }


    onSelectAddress(addressId: number | any) {
        if (this.selectionMode == false)
            return;

        this.selectionChange.emit(addressId);
    }


    onEdit() {
        let editCustomerAddressData: EditCustomerAddressData = new EditCustomerAddressData({
            address: this.address,
            isDeliveryAddress: this.isDeliveryAddress
        });
        let dialogRef = this.dialog.open(EditCustomerAddressComponent, {
            data: editCustomerAddressData,
            role: "dialog",
            hasBackdrop: true,
            // disableClose: true
        });
        dialogRef.afterClosed().pipe(this.takeUntilDestroy())
            .subscribe(address => {
                    if (address) {
                        this.edited.emit(address);
                    }
                }
            )
    }

    onRemove() {
        this.customerAccountService
            .removeCustomerAddressById(this.address.id,this.isDeliveryAddress).pipe(this.takeUntilDestroy())
            .subscribe(removed => {
                    if (removed) {
                        this.removed.emit(this.address);
                    }
                }
            );
    }


    get addressText() {
        if (this.address) {
            let line1 = this.address.line1 + ' ' + (this.address.line2 ?? ''),
                countryName: string = this.address.country?.name ?? '',
                cityName: string = this.address.city?.name ?? '',
                townName: string = this.address.town?.name ?? '';
            return `${line1}${townName}, ${cityName}, ${countryName}`;
        }

        return '';
    }


    ngOnChanges(changes: SimpleChanges): void {
        if (changes) {
            let changeForm: SimpleChange = changes['group'];
            if (changeForm) {
                this.group = changeForm.currentValue;
            }

            let value: SimpleChange = changes['value'];
            if (value) {
                this.selectedAddressId = value.currentValue;
            }
        }
    }



    override ngOnDestroy(): void {
        super.ngOnDestroy();
        // if (this.isSelected()){
        //     this.onSelectAddress(null);
        // }
    }

}
